import React, { useState, useEffect, useMemo } from "react";
import { Link, useHistory } from "react-router-dom";
//import { Button } from "reactstrap";
import moment from "moment";
import axios from "../services/axios";
import ReactLoading from "react-loading";
import RSelect from "react-select";
import RDatePicker from "react-datepicker";
import FormContacts from "../pages/Dashboard/FormContacts";
import FormContactsDropdown from "../pages/Dashboard/FormContactsDropdown";
import cx from "classnames";
import isAdmin from "../services/isAdmin";
import saveLog from "../services/saveLog";
import swal from "sweetalert";
import { data } from "jquery";
import { Card, Checkbox, Modal, Popconfirm } from "antd";
import dumpRights from "../services/dumpRights";
// import $ from "jquery";
// $.DataTable = require("datatables.net");
// require("datatables.net-bs4");
import Axios from "axios";
import url from "../services/url";
import { Tabs } from "antd";
import isConsultant from "../services/isConsultant";

import exportFromJSON from "export-from-json";
import CandidateSingleView from "./CandidateSingleView";
import ContactCreator from "../pages/Dashboard/FormContacts/ContactCreator";
import { useLocation } from "react-router-dom";
import { Else } from "react-condition";
import CandidateHistory from "./CandidateHistory";
import { Select } from "antd";
import locations from "../utils/api/locations";
import { formatDateDDMMYYYY } from "../utils/commonFunctions";
function CandidatesTable({
  info,
  csvDownload,
  setAppPage,
  LengthPages,
  setInput,
  Input,
  GetValue,
  setFormIds,
  formIds,
  positionName,
  setPositionName,
  candidates,
  setCandidates,
  hideFilter = [],
  hideFilters = [],
  controls,

  setLocationName,
  locationName,
  setCandidateStatus,
  candidateStatus,
  setProcessId,
  processId,
  setStartDates,
  startDates,
  setEndDates,
  endDates,
  csv,
  setCsv,
  sta,
  setSta,
  load,
  setLoad,
  setSource,
  source,
  setTrfData,
  trfData,
  setAppRecStatus,
  appRecStatus,
  selectedTrf,

  score,
  setScore,
  interviewRounds,
  setInterviewRounds,
  setInterviewRoundLevel,
  designation,
  setDesignation,
  ...props
}) {
  // Stateful Hooks
  // const pageCount = 10;
  // const totalPages = Math.ceil(candidates.length / pageCount);
  const [Sli, SetSli] = useState(10);
  const [page, setPage] = useState(0);
  const [positionFilter, setPositionFilter] = useState();
  const [locationFilter, setLocationFilter] = useState();
  const [statusFilter, setStatusFilter] = useState();
  const [startDateFilter, setStartDateFilter] = useState(
    new Date(new Date().getFullYear(), new Date().getMonth(), 1)
  );
  const [endDateFilter, setEndDateFilter] = useState(new Date());
  const [showDate, setShowDate] = useState("");
  const [showDate2, setShowDate2] = useState("");
  const [showID, setShowID] = useState(true);
  const [search, setSearch] = useState("");
  const history = useHistory();
  const [sort, setSort] = useState("dateApplied");
  const [sortOrder, setSortOrder] = useState(-1);
  const [error, setError] = useState(true);
  const [number, setNumber] = useState();

  // csv data filter a/q to form
  const [formId, setFormId] = useState([]);
  const [formName, setFormName] = useState([]);
  const [process, setProcess] = useState([]);
  const [candidateInformation, setCandidateInformation] = useState([]);
  const [bulkInfo, setBulkInfo] = useState([]);
  const [cid, setCid] = useState("");
  const [phone, setPhone] = useState("");
  const [trfCollection, setTrfCollection] = useState([]);
  const [checkValid, setCheckValid] = useState(false);

  const [buttonDisable, setButtonDisable] = useState(false);

  const location = useLocation();
  let eData = location?.state;
  const [designationsArray, setDesignationArray] = useState([]);

  const [isModalVisible, setIsModalVisible] = useState(false);

  const [preferredLocation, setPreferredLocation] = useState([]);

  const interViewRound = ["L1", "L2", "versant", "final", "clientRound"];

  const [checked, setChecked] = React.useState(true);

  const pathCheck = ["/reports/l1", "/reports/l2", "/reports/l3"];
  const path = history.location.pathname;
  const [rejectionReasonStatus, setRejectionReasonStatus] = useState([]);

  const onChange = (value) => {
    console.log(`selected ${value}`);
  };
  const onSearch = (value) => {
    console.log("search:", value);
  };

  // const CandidateStatus = pathCheck.includes(path)
  //   ? ["Selected", "On Hold", "Rejected", "Pending"]
  //   : ["Selected", "On Hold", "Rejected", "Pending"];
  useEffect(() => {
    Axios.get(url("/statusParametersMaster"), {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("user.token")}`,
      },
    }).then((res) => {
      // reasonData = res.data;
      setRejectionReasonStatus(res?.data);
    });
  }, []);

  const CandidateStatus = ["Selected", "On Hold", "Rejected", "Pending"];

  const candidateScore = ["Test Attempt", "Test Not Attempt"];
  const details = ["Name", "Email", "Phone Number", "Date of Birth", "Gender"];
  const technicalDetails = [
    "Highest Qualification",
    "Indian Languages",
    "Type of Internet Connectivity",
    "Any specific experience do you have?",
    "Preferred Location",
    "How did you come to know about us",
  ];
  const tableData = [
    "Name",
    "Email",
    "Phone Number",
    "How did you come to know about us",
  ];

  const [logStatus, setLogStatus] = useState({});
  const [logDate, setLogDate] = useState("");

  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);

  const showModal = () => {
    setVisible(true);
  };

  const handleOk = () => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      setVisible(false);
    }, 3000);
  };

  const handleCancel = () => {
    setVisible(false);
  };

  useEffect(() => {
    axios
      .get("/processes", {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("user.token")}`,
        },
      })
      .then((res) => {
        const data = res.data.processes;
        setProcess(data);
      });

    axios
      .get(`/trf?Department=&Location=&trfStatus=${true}&isTRFAssignable`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("user.token")}`,
        },
      })
      .then((res) => {
        const data = res.data;
        setTrfCollection(data);
      });

    axios
      .get(`/Designation`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("user.token")}`,
        },
      })
      .then((res) => {
        setDesignationArray(res.data.designation);
      });
  }, []);

  // console.log("trf collection name here", trfCollection);

  //let filteredDate = [];
  // Effects
  useEffect(() => {
    setShowID(false);
  }, [candidates]);

  // //for searching
  // if (search.length >= 3) {
  //   setInput(search);
  //   setAppPage(1);
  // } else if (search.length === 0) {
  //   setInput("");
  //   //setAppPage(1)
  // }

  const onClickSearch = () => {
    setInput(search);
    setAppPage(1);
  };

  const handleSearch = (e) => {
    const val = e.target.value;
    localStorage.setItem("numberSearch", e.target.value);

    setSearch(val);
    setSearch(localStorage.setItem("numberSearch", val));
    setSearch(val);
    setCandidateInformation([]);
  };

  //Previous Button
  const PreviousButton = () => {
    SetSli(Sli - 10);
  };

  //NextButton function
  const NextButton = () => {
    SetSli(Sli + 10);
  };

  //ArrayLength
  const PageNo = [];
  for (let i = 0; i < Math.ceil(LengthPages / 10) + 1; i++) {
    PageNo.push(i);
  }
  // for(let i=0;i<300;i++){
  //   PageNo.push(i)
  // }

  // Events
  function toggleSortOrder() {
    if (sortOrder === 0) {
      setSortOrder(1);
    } else if (sortOrder === 1) {
      setSortOrder(-1);
    } else if (sortOrder === -1) {
      setSortOrder(0);
    } else {
      setSortOrder(0);
    }
  }

  function onClickView(event) {
    const id = event.target.getAttribute("candidate");
    history.push("/candidate/" + id);
  }

  function MouseEnter(value) {
    const id = value.id;
    history.push("/candidate/" + id);
  }

  function accepted() {
    history.push("/candidate/" + cid);
  }

  async function mouseClick(candidate) {
    const candidateId = candidate.id;
    const phone = candidate["Phone Number"];
    checkInactive(candidate["Phone Number"]);
    setCid(candidateId);
    setPhone(phone);
    try {
      const { data } = await axios.get("candidates/" + candidateId, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("user.token")}`,
        },
      });
      setCandidateInformation(data?.responses);
      setBulkInfo(data);
    } catch (e) {
      console.error(e);
    }

    //Interview updated Status
    await axios
      .get(`/interviews/interviewLogs/${candidateId}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("user.token")}`,
        },
      })
      .then((res) => {
        const data = res.data;
        setLogStatus(data[0]?.candidateId);
        setLogDate(data[0]?.logDate);
      });
  }

  function checkInactive(phone) {
    setCheckValid(false);
    axios
      .get(`/candidates/InActiveCandidate/${phone}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("user.token")}`,
        },
      })
      .then((res) => {
        if (res?.data?.candidates?.length === 0) {
          setCheckValid(true);
        }
      });
  }

  function onClickEdit(event) {
    const id = event.target.getAttribute("candidate");
    history.push("/candidate/" + id + "/edit");
  }

  function onClickDelete(id) {
    // const id = event.target.getAttribute("candidate");
    saveLog(
      "CANDIDATE_DELETE",
      "Deleted candidate " +
        (candidates.find((candidate) => candidate.id === id)?.name || id)
    );
    axios
      .delete("candidates/" + id, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("user.token")}`,
        },
      })
      .then((res) => {
        setCandidates((previousCandidates) => {
          return previousCandidates.filter((candidate) => {
            if (candidate.id === id) {
              return false;
            }
            return true;
          });
        });
      })
      .catch(console.error);
  }

  // Use flatten to convert nested JSON data into csv form
  const flatten = function (data) {
    var result = {};
    function recurse(cur, prop) {
      if (Object(cur) !== cur) {
        result[prop] = cur;
      } else if (Array.isArray(cur)) {
        for (var i = 0, l = cur.length; i < l; i++)
          recurse(cur[i], prop + "[" + i + "]");
        if (l == 0) result[prop] = [];
      } else {
        var isEmpty = true;
        for (var p in cur) {
          isEmpty = false;
          recurse(cur[p], p);
        }
        if (isEmpty && prop) result[prop] = {};
      }
    }
    recurse(data, "");
    return result;
  };

  // api for formname and id
  useEffect(() => {
    axios
      .get("/formtemplate", {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("user.token")}`,
        },
      })
      .then((res) => {
        const data = res.data;
        setFormName(data);
      });

    if (eData?.tId !== undefined) {
      setTrfData(eData.tId);
    }
  }, [eData?.tId]);

  const handleStatus = (e) => {
    setAppPage(1);
    const status = e.target.value;
    localStorage.setItem("selectStatus", e.target.value);
    setCandidateStatus(status);
    setCandidateInformation([]);
  };

  const handleScore = (e) => {
    setAppPage(1);
    const scores = e.target.value;
    localStorage.setItem("selectScore", e.target.value);
    setScore(scores);
    setCandidateInformation([]);
  };

  const handleInterviewRound = (e) => {
    setAppPage(1);
    const interViewRound = e.target.value;
    localStorage.setItem("interviewRoundLevel", e.target.value);
    setInterviewRoundLevel(interViewRound);
    setCandidateInformation([]);
  };

  const handleApplicationStatus = (e) => {
    localStorage.setItem("trf_ids", "");
    setAppPage(1);
    const formIds = localStorage.getItem("form_ids");
    // localStorage.removeItem("trf_ids");
    const status = e.target.checked;

    if (eData !== undefined && eData !== null) {
      eData.tId = undefined;
    }

    // if (formIds !== "" && formIds !== null) {
    if (status === true) {
      localStorage.setItem("selectInterviewRound", "Application_Received");

      setInterviewRounds("Application_Received");
    } else {
      localStorage.removeItem("selectInterviewRound");
      setInterviewRounds("");
    }

    setAppRecStatus(!appRecStatus);
    // } else {
    //   setChecked(false);
    //   swal({
    //     title: "Please select form type for candidate information",
    //   });
    // }

    setCandidateInformation([]);
  };
  const handleLocationSelect = (e) => {
    setAppPage(1);
    setCandidateInformation([]);
    const name = e.target.value;
    localStorage.setItem("selectLocation", e.target.value);
    setLocationName(name);
  };

  // const handleProcesses = (e) => {
  //   setAppPage(1);
  //   const ids = e.target.value;
  //   localStorage.setItem("selectProcess", e.target.value);
  //   setProcessId(ids);
  //   setCandidateInformation([]);
  // };

  //Trf handler
  const handleTrf = (e) => {
    if (eData !== undefined && eData !== null) {
      eData.tId = undefined;
    }
    if (eData !== undefined && eData !== null) {
      eData.tValues = undefined;
    }
    localStorage.setItem("trf_ids", e);
    setTrfData(e);
    localStorage.removeItem("selectLocation");
    localStorage.removeItem("selectProcess");
    localStorage.removeItem("selectScore");
    localStorage.removeItem("selectInterviewRound");
    localStorage.removeItem("selectStatus");
    localStorage.removeItem("numberSearch");
    localStorage.setItem("numberSearch", "");
    localStorage.removeItem("selectSource");
  };

  const handleSelect = (e) => {
    setAppPage(1);
    const ids = e.target.value;
    localStorage.setItem("form_ids", e.target.value);
    localStorage.removeItem("selectLocation");
    localStorage.removeItem("selectProcess");
    localStorage.removeItem("selectScore");
    localStorage.removeItem("selectInterviewRound");
    localStorage.removeItem("selectStatus");
    localStorage.removeItem("numberSearch");
    localStorage.setItem("numberSearch", "");
    localStorage.removeItem("selectSource");
    localStorage.removeItem("designation");
    setFormIds(ids);
    setLocationName("");
    setProcessId("");
    setCandidateStatus("");
    setFormId([]);
    setScore("");
    setSource("");
    setSearch("");
    setDesignation("");
    setStartDateFilter(
      new Date(new Date().getFullYear(), new Date().getMonth(), 1)
    );
    setEndDateFilter(new Date());
    setCandidateInformation([]);
    //setCsv([])
    setChecked(false);
    setAppRecStatus(false);
  };

  const handleSelectDesignation = (e) => {
    setDesignation(e.target.value);
    localStorage.setItem("designation", e.target.value);
    if (e.target.value) {
      localStorage.removeItem("selectScore");
      localStorage.removeItem("selectSource");
    }
  };

  const handleSelectSource = (e) => {
    setAppPage(1);
    if (e.target.value === "BulkUpload") {
      localStorage.removeItem("selectStatus");
      localStorage.removeItem("selectLocation");
      localStorage.removeItem("selectProcess");
      localStorage.removeItem("selectScore");
      localStorage.removeItem("selectInterviewRound");
      setCandidateStatus("");
      setLocationName("");
      setProcessId("");
      setScore("");

      setCandidateInformation("");
      setCandidateInformation([]);
    } else {
      setBulkInfo("");
    }
    const source = e.target.value;
    localStorage.setItem("selectSource", e.target.value);
    setSource(source);
  };
  const selectedSource = ["BulkUpload"];

  const [bulkUploadFormId, setBulkUploadFormId] = useState("");
  const [modalClose, setModalClose] = useState("");
  const handleSelectBulkUpload = (e) => {
    setBulkUploadFormId(e.target.value);
  };

  const data = candidates?.map((el) => {
    // const dat = new Date(el.dateApplied).toISOString();

    // if (el.dateApplied) {
    //   el.dateApplied = dat;
    // }
    let parsedDetails = el?.personalDetails;
    if (parsedDetails["Preferred Location"]) {
      parsedDetails["Preferred Location"] =
        parsedDetails["Preferred Location"].toString();
    }
    if (parsedDetails["Select your working days (weekends are mandatory)"]) {
      parsedDetails["Select your working days (weekends are mandatory)"] =
        parsedDetails[
          "Select your working days (weekends are mandatory)"
        ].toString();
    }
    if (parsedDetails["Select your working days ( weekends are mandatory)"]) {
      parsedDetails["Select your working days ( weekends are mandatory)"] =
        parsedDetails[
          "Select your working days ( weekends are mandatory)"
        ].toString();
    }

    if (el.personalDetails["Indian Languages"]) {
      el.personalDetails["Indian Languages"] =
        el.personalDetails["Indian Languages"].toString();
    }

    return flatten(el);
  });

  //const exportType = 'csv'

  const [status, setStatus] = useState();
  const [dataStatus, setDataStatus] = useState();

  // async function onClickDownloadCSV() {
  //   const candidateData = await csvDownload();
  //   const exportType = "csv";
  //   if (source !== "BulkUpload") {
  //     const data = candidateData.map((candidate) => {
  //       const personalDetails = candidate.personalDetails;
  //       Object.entries(personalDetails).forEach(([key, value]) => {
  //         if (Array.isArray(value)) {
  //           personalDetails[key] = value.toString();
  //         }
  //       });
  //       Object.assign(candidate, personalDetails);
  //       delete candidate.personalDetails;

  //       // Flatten trfId
  //       if (candidate.trfId) {
  //         Object.entries(candidate.trfId).forEach(([key, value]) => {
  //           if (Array.isArray(value)) {
  //             candidate.trfId[key] = value.toString();
  //           }
  //         });
  //         Object.assign(candidate, candidate.trfId);
  //         delete candidate.trfId;
  //       }
  //       return candidate;
  //     });
  //     let fileName = `Candidates_${moment(new Date()).format(
  //       "DD-MM-YYYY_HH:mm"
  //     )}`;
  //     if (data && data?.length > 0 && !dataStatus) {
  //       exportFromJSON({ data, fileName, exportType });
  //     }
  //   } else {
  //     const data = candidateData;
  //     let fileName = `Candidates_BulkUpload_${moment(new Date()).format(
  //       "DD-MM-YYYY_HH:mm"
  //     )}`;
  //     if (data && data?.length > 0 && !dataStatus) {
  //       exportFromJSON({ data, fileName, exportType });
  //     }
  //   }

  //   // let FormType=document.getElementById("FormType").value;
  // }
  async function onClickDownloadCSV() {
    let FormType = document.getElementById("FormType").value;
    // if (FormType === "") {
    //   swal({
    //     title: "Please Select Form Name",
    //   });
    //   return;
    // }
    const candidateData = await csvDownload();
    let data = [];
    const exportType = "csv";

    const flattens = function (data) {
      var result = {};
      function sanitizeField(field) {
        return field.replace(/[^\w\s]/gi, '');
      }
      function recurse(cur, prop) {
        if (Object(cur) !== cur) {
          result[sanitizeField(prop)] = cur;
        } else if (Array.isArray(cur)) {
          for (var i = 0, l = cur.length; i < l; i++)
            recurse(cur[i], sanitizeField(prop) + "[" + i + "]");
          if (l == 0) result[sanitizeField(prop)] = [];
        } else {
          var isEmpty = true;
          for (var p in cur) {
            isEmpty = false;
            recurse(cur[p], sanitizeField(p));
          }
          if (isEmpty && prop) result[sanitizeField(prop)] = {};
        }
      }
      recurse(data, "");
      return result;
    };

    data =
      candidateData &&
      candidateData.map((el) => {
        if (el.personalDetails["Preferred Location"]) {
          el.personalDetails["Preferred Location"] =
            el.personalDetails["Preferred Location"].toString();
        }
        if (
          el.personalDetails[
            "Select your working days (weekends are mandatory)"
          ]
        ) {
          el.personalDetails[
            "Select your working days (weekends are mandatory)"
          ] =
            el.personalDetails[
              "Select your working days (weekends are mandatory)"
            ].toString();
        }

        if (
          el.personalDetails[
            "Select your working days ( weekends are mandatory)"
          ]
        ) {
          el.personalDetails[
            "Select your working days ( weekends are mandatory)"
          ] =
            el.personalDetails[
              "Select your working days ( weekends are mandatory)"
            ].toString();
        }

        if (el.personalDetails["Type of Internet Connectivity"]) {
          el.personalDetails["Type of Internet Connectivity"] =
            el.personalDetails["Type of Internet Connectivity"].toString();
        }

        if (el.personalDetails["Type of system available"]) {
          el.personalDetails["Type of system available"] =
            el.personalDetails["Type of system available"].toString();
        }

        return flattens(el);
      });
    let fileName = `Candidates_${moment(new Date()).format(
      "DD-MM-YYYY_HH:mm"
    )}`;
    // let FormType=document.getElementById("FormType").value;
    if (data && data?.length > 0 && !dataStatus) {
      exportFromJSON({ data, fileName, exportType });
    }
    //  else if (FormType === "") {
    //   swal({
    //     title: "Please Select Form Name",
    //   });
    // }
    // else if(FormType !== "" &&  data.length === 0){
    //   setStatus(true)
    // }
  }

  function onClickDownloadCSVOld(event) {
    let candidates = [];
    let rows = [];
    //   .DataTable()
    //   .rows({ search: "applied" })
    //   .nodes();
    for (let i = 0; i < rows.length; i++) {
      const candidate = JSON.parse(rows[i].getAttribute("candidate"));
      candidates.push(candidate);
    }
    rows = [];
    rows.push(Object.keys(candidates[0]));
    candidates.forEach((candidate) => {
      rows.push(
        Object.values(candidate).map((value) => {
          return '"' + value + '"';
        })
      );
    });
    let csv =
      "data:text/csv;charset=utf-8," + rows.map((e) => e.join(",")).join("\n");
    var encodedUri = encodeURI(csv);
    var link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", "candidates.csv");
    document.body.appendChild(link); // Required for FF
    link.click();
  }

  function onClickClearFilters() {
    setLocationFilter();
    setPositionFilter();
    setStatusFilter();
    setStartDateFilter(
      new Date(new Date().getFullYear(), new Date().getMonth(), 1)
    );
    setEndDateFilter(new Date());
    setSearch("");
    setScore("");
    setSource("");
  }

  function onClickToggleID() {
    setShowID(!showID);
  }

  function camel2normal(str) {
    return str.replace(/([A-Z])/g, " $1").replace(/^./, function (str) {
      return str.toUpperCase();
    });
  }

  function reactSelectOptionMap(list, key) {
    let temp = list.map((item) => {
      return item[key];
    });
    temp = [...new Set(temp)].map((item) => {
      return {
        label: item,
        value: item,
      };
    });
    return temp.filter((nulledObject) => {
      if (!nulledObject.label && !nulledObject.value) {
        return false;
      }
      return true;
    });
  }

  let positionOptions = reactSelectOptionMap(candidates, "position");
  let locationOptions = reactSelectOptionMap(candidates, "location");
  let statusOptions = reactSelectOptionMap(candidates, "status");

  // if (candidates.length <= 0) {
  //   return (
  //     <h4 className="text-primary text-center">
  //       There are no candidates to show.
  //     </h4>
  //   );
  // }

  // let candidateFields = Object.keys(candidates[0]).filter((field) => {
  //   if (field == "id") return false;
  //   if (field == "personalDetails") return false;
  //   if (field == "uid") return false;
  //   let hide = false;
  //   hideFilter.forEach((filter) => {
  //     if (field == filter) hide = true;
  //   });
  //   if (hide === true) return false;
  //   return true;
  // });
  const [count, setCount] = useState(0);

  useEffect(() => {
    let count = 0;
    let compare = 0;
    data.length > 0 &&
      data.map((ele, i) => {
        compare = Object.keys(ele).length;

        if (count <= compare) {
          count = compare;
          setCount(i);
          // console.log("runned success", i);
        }
      });
    // console.log("not runned success")
  }, [formIds, data, trfData, checked]);

  const [candidateField, setCandidateField] = useState([]);

  useEffect(() => {
    setCandidateField(
      data?.length > 0 && data[count] !== undefined && Object.keys(data[count])
    );
  }, [count, formIds, load, trfData]);

  async function checkStatus() {
    const data = await localStorage.getItem(
      "selectInterviewRound",
      "Application_Received"
    );
    if (data === "" || data === undefined || data === null) {
      setAppRecStatus(false);
    }
  }

  // let candidateField = data.length > 0 &&  Object.keys(data[count]).filter((field) => {
  //   return true
  // });

  // async function fetchKey(){
  //   let candidateField = await data.length > 0 &&  Object.keys(data[count]).filter((field) => {
  //   return true
  // });
  // }

  const [statusValue, setStatusValue] = useState(false);
  //if(candidates.)

  useEffect(() => {
    data?.map((ele) => {
      if (
        formIds !== "" &&
        ele["Preferred Location"] &&
        ele["Preferred Location"]?.length !== 0
      ) {
        setStatusValue(!statusValue);
        return;
      }
    });
  }, [formIds]);
  // Data not found validation on filters
  useEffect(() => {
    if (
      (trfData !== "" && processId !== "" && trfData !== null) ||
      (formIds !== "" && processId !== "" && formIds !== null)
    ) {
      setError(false);
    } else if (
      (trfData !== "" && data.length === 0 && trfData !== null) ||
      (formIds !== "" && data.length === 0 && formIds !== null)
    ) {
      setError(false);
    } else if (trfData === "" || formIds === "") {
      setError(true);
    }
  }, [processId, trfData, formIds]);

  // useEffect(() => {
  //   if (Input !== "" && data.length <= 0 ) {
  //     setError(false)

  //   }
  // }, [Input])

  useEffect(() => {
    if (
      trfData === "" ||
      trfData === null ||
      formIds === "" ||
      formIds === null
    ) {
      setError(true);
    } else if (
      (trfData !== "" && Input !== "" && data.length <= 0) ||
      (formIds !== "" && Input !== "" && data.length <= 0)
    ) {
      setError(false);
    }
  }, [Input]);

  //http://172.17.103.25:4000/api/candidates/PreferedLocation/619b6b470f058f6def2364d2
  const [preferred, setPreferred] = useState(false);
  const [check, setCheck] = useState(true);

  useEffect(() => {
  
    formIds !== "" &&
      formIds !== null &&
      axios
        .get(`candidates/PreferedLocation/${formIds}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("user.token")}`,
          },
        })
        .then((res) => {
          const data = res.data !== null ? res.data.elements : [];
          setPreferred(false);
          setCheck(false);
          data.length > 0 &&
            data.map((ele) => {
              if (ele?.properties?.label === "Preferred Location") {
                setPreferred(true);
              }
            });
        });

    locations().then((res) => {
      setPreferredLocation(res);
    });
  }, [formIds]);

  // calender enable disable date
  const [disabledDate, setDisabledDate] = useState(new Date());

  useEffect(() => {
    const date = new Date(
      startDateFilter.getFullYear(),
      startDateFilter.getMonth() + 3,
      startDateFilter.getDate()
    );
    if (date < new Date()) {
      setDisabledDate(date);
    } else {
      setDisabledDate(new Date());
    }
  }, [startDateFilter]);

  //Bulk upload functionality
  async function editCandidate(event) {
    const id = await event.target.getAttribute("candidate");
    const response = await axios.get(`/candidates/${id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("user.token")}`,
      },
    });

    const form_id = response.data.form._id;

    window.location.replace("/edit/" + form_id + "/" + id);
  }

  async function updateCandidate(event) {
    const id = await event.target.getAttribute("candidate");
    const response = await axios.get(`/candidates/${id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("user.token")}`,
      },
    });
    const form_id = response.data.form._id;

    window.location.replace("/candidate-update/" + form_id + "/" + id);
  }
  // const showOption = () => {
  //   const panel = document.getElementById("search-panel");
  //   if (panel.style.display === "none") {
  //     panel.style.display = "flex";
  //   } else {
  //     panel.style.display = "none";
  //   }
  // };

  const { TabPane } = Tabs;

  const dateConverter = (startDateFilter, endDateFilter) => {
    const dateFormat = new Date(startDateFilter);
    const dateFor = new Date(
      dateFormat.getFullYear(),
      dateFormat.getMonth(),
      dateFormat.getDate() + 1
    );
    const timeSpan = new Date(dateFor).toISOString();
    const date = timeSpan.split("T");
    let p = date[0].split(/\D/g);
    let t = date[1].split(".");

    // {(startDateFilter !== null && endDateFilter !== null) && setShowDate([p[2], p[1], p[0]].join("-") + " to " + [p2[2], p2[1], p2[0]].join("-"))}
    
      startDateFilter !== null && setShowDate([p[2], p[1], p[0]].join("-"));
      endDateFilter === null && setShowDate2("");
    
  };

  const endDateConverter = (endDateFilter) => {
    const data =
      endDateFilter === new Date()
        ? endDateFilter
        : new Date(
            endDateFilter.getFullYear(),
            endDateFilter.getMonth(),
            endDateFilter.getDate() + 1
          );
    const timeSpan2 = new Date(data).toISOString();
    const date2 = timeSpan2.split("T");
    let p2 = date2[0].split(/\D/g);
    let t2 = date2[1].split(".");

    endDateFilter !== null && setShowDate2([p2[2], p2[1], p2[0]].join("-"));
  };

  useEffect(() => {
    startDateFilter !== null && dateConverter(startDateFilter, endDateFilter);
    endDateFilter !== null && endDateConverter(endDateFilter);
  }, [startDateFilter, endDateFilter]);

  const showAdvanced = () => {
    const div = document.getElementById("advanced-search");
    if (div.style.display === "none") {
      document.getElementById("advanced-search").style.display = "flex";
    } else {
      document.getElementById("advanced-search").style.display = "none";
    }
  };

  // async function saveInterviewLog() {
  //   await axios
  //     .get(`/interviews/interviewLogs/${candidate._id}`, {
  //       headers: {
  //         Authorization: `Bearer ${localStorage.getItem("user.token")}`,
  //       },
  //     })
  //     .then((res) => {
  //       const data = res.data;
  //       setLogStatus(data);
  //     });
  // }
  const [historyStatus, setHistoryStatus] = useState(false);
  const candidateHistory = () => {
    setIsModalVisible(true);
  };

  const handleHistoryOk = () => {
    setIsModalVisible(false);
  };

  const handleHistoryCancel = () => {
    setIsModalVisible(false);
  };

  return (
    <div>
      {!isConsultant() && (
        <div className="row candidate mb-4">
          <div className="col-lg-12 col-md-12 col-sm-12">
            <div className="row mb-2 cursor-pointer">
              {/* <div className="py-2 px-3" onClick={showOption}>
            <i className="fa fa-filter"></i>
          </div> */}

              <div className="my-2 p-3 border bg-white w-100">
                <div className="d-flex flex-row justify-content-end">
                  <Checkbox
                    checked={appRecStatus}
                    onChange={handleApplicationStatus}
                  >
                    Application Received
                  </Checkbox>
                  <div
                    style={{
                      borderRight: "1px solid rgb(0 0 0 / 25%)",
                      height: 25,
                    }}
                  ></div>
                  <label onClick={showAdvanced} className="pl-2">
                    <i class="fa fa-filter" aria-hidden="true"></i> Filter
                  </label>
                </div>
                <div className="mt-2">
                  <div className="row">
                    {!appRecStatus && (
                      <div className="col-md-3 px-1">
                        <div className="">
                          <Select
                            style={{
                              width: '100%',
                            }}
                            showSearch
                            placeholder="Select TRF"
                            optionFilterProp="children"
                            onChange={handleTrf}
                            onSearch={onSearch}
                            filterOption={(input, option) =>
                              (option?.label ?? "")
                                .toLowerCase()
                                .includes(input.toLowerCase())
                            }
                            value={trfCollection
                              ?.filter((ele) => {
                                return (
                                  ele._id === localStorage.getItem("trf_ids")
                                );
                              })
                              .map((option) => {
                                let d = `${option?.title}-${
                                  option?.department
                                }-${option?.location}-${
                                  option?.processName
                                }-${moment(option?.tat)
                                  .utc()
                                  .format("YYYY-MM-DD")}${
                                  option?.workModal ? `-${option.workModal}` : ""
                                }`;

                                return {
                                  label: d,
                                  value: option?._id,
                                };
                              })}
                            options={[
                              { label: "Select...", value: "" },
                              ...trfCollection?.map((option) => {
                                let d = `${option?.title}-${
                                  option?.department
                                }-${option?.location}-${
                                  option?.processName
                                }-${moment(option?.tat)
                                  .utc()
                                  .format("YYYY-MM-DD")}${
                                  option?.workModal ? `-${option.workModal}` : ""
                                }`;

                                return {
                                  label: d,
                                  value: option?._id,
                                };
                              }),
                            ]}
                          />
                        </div>
                      </div>
                    )}

                    <div className="col-md-3 px-1">
                      <select
                        id="FormType"
                        className="mb-2 form-control"
                        onChange={handleSelect}
                        value={localStorage.getItem("form_ids")}
                      >
                        <option value="" selected="true">
                          Form Type
                        </option>
                        {formName &&
                          formName
                            .filter((ele) => {
                              return ele?.formType !== "Document_Form";
                            })
                            .map((obj) => {
                              return (
                                <option
                                  //selected
                                  value={obj._id}
                                >
                                  {obj.name}
                                </option>
                              );
                            })}
                      </select>
                    </div>
                    {(formIds === "633190214529e62d9edc2fff" ||
                      formIds === "62e91154309f9f7d5806d044") && (
                      <div className="col-md-3 px-1">
                        <select
                          id="FormType"
                          className="mb-2 form-control"
                          onChange={handleSelectDesignation}
                          value={localStorage.getItem("designation")}
                        >
                          <option value="" selected="true">
                            Select designation
                          </option>
                          {designationsArray &&
                            designationsArray.map((obj) => {
                              return (
                                <option
                                  //selected
                                  value={obj.designation}
                                >
                                  {obj.designation}
                                </option>
                              );
                            })}
                        </select>
                      </div>
                    )}
                    <div className="col-md-3 d-flex px-1">
                      {/* <h6 className="text-dark">Application Date</h6> */}
                      <RDatePicker
                        className="form-control"
                        minDate={
                          new Date(
                            new Date().setMonth(new Date().getMonth() - 12)
                          )
                        }
                        maxDate={disabledDate}
                        // selected={startDateFilter}
                        //  selected={}
                        value={startDateFilter}
                        startDate={startDateFilter}
                        endDate={endDateFilter}
                        onChange={(dates) => {
                          const [start, end] = dates;
                          setStartDateFilter(start);
                          setEndDateFilter(end);
                        }}
                        selectsRange
                        // inline
                        placeholderText={`${showDate} ${
                          showDate2 && "to"
                        } ${showDate2}`}
                      /> 
                      &nbsp;&nbsp; 
                      <div className="mb-1">
                        <button
                          className="btn btn-primary btn-block"
                          onClick={onClickClearFilters}
                        >
                          <i className="fa fa-refresh" aria-hidden="true"></i>
                        </button>
                      </div>
                      <div className="mb-1 ml-1">
                        {sta !== undefined && sta === false ? (
                          <button
                            disabled={buttonDisable}
                            className="btn btn-primary btn-block"
                            onClick={onClickDownloadCSV}
                          >
                            <i
                              className="fa fa-refresh fa-spin"
                              style={{ marginRight: "5px" }}
                            />{" "}
                            Data Processing...
                          </button>
                        ) : (
                          <button
                            disabled={buttonDisable}
                            className="btn btn-primary btn-block"
                            onClick={onClickDownloadCSV}
                          >
                            <i
                              className="fa fa-download"
                              aria-hidden="true"
                            ></i>
                          </button>
                        )}
                      </div>
                    </div>
                    <div className="col-md-3 px-1">
                      <select
                        id="FormType"
                        className="mb-2 form-control"
                        onChange={handleLocationSelect}
                        value={
                          localStorage.getItem("selectLocation")
                            ? localStorage.getItem("selectLocation")
                            : ""
                        }
                      >
                        <option value="" selected="true">
                          Preferred Location
                        </option>
                        {preferredLocation?.map((obj) => {
                          return (
                            <option
                              //selected
                              value={obj?.locationName}
                            >
                              {obj?.locationName}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                    <div className="col-md-3 px-1">
                      {/* {formIds !== "" && ( */}
                      <div className="d-flex">
                        <input
                          type="text"
                          // maxlength="10"
                          //onkeypress="return event.charCode>=48 && event.charCode<=57"
                          className="form-control"
                          placeholder="Search..."
                          value={
                            localStorage.getItem("numberSearch")
                              ? localStorage.getItem("numberSearch")
                              : ""
                          }
                          onChange={handleSearch}
                        />
                        {number !== "" && (
                          <span style={{ color: "red", fontSize: "15px" }}>
                            {number}
                          </span>
                        )}
                        &nbsp;&nbsp;
                        <button
                          onClick={onClickSearch}
                          className="btn btn-primary "
                        >
                          search
                        </button>
                      </div>
                      {/* )} */}
                    </div>
                    {/* {formIds !== "" && ( */}
                    <div className="col-md-2 px-1">
                      <button
                        onClick={showModal}
                        className="btn btn-primary btn-block"
                      >
                        <i className="fa fa-plus" aria-hidden="true"></i>{" "}
                        Candidate
                      </button>
                    </div>
                    {/* )} */}
                  </div>
                  <div
                    className="row mt-2"
                    id="advanced-search"
                    style={{ display: "none" }}
                  >
                    {!pathCheck.includes(path) &&
                      interviewRounds !== "Application_Received" && (
                        <div className="col-md-2 px-1">
                          <select
                            id="FormType"
                            className="form-control"
                            onChange={handleInterviewRound}
                            value={
                              localStorage.getItem("interviewRoundLevel")
                                ? localStorage.getItem("interviewRoundLevel")
                                : ""
                            }
                          >
                            <option value="" selected="true">
                              Select Interview
                            </option>
                            {check &&
                              interViewRound.map((obj) => {
                                return (
                                  <option value={obj}>
                                    {obj.charAt(0).toUpperCase() +
                                      obj.slice(1).toLowerCase()}
                                  </option>
                                );
                              })}
                          </select>
                        </div>
                      )}

                    {interviewRounds !== "Application_Received" && (
                      <div className="col-md-3 px-1">
                        <select
                          id="FormType"
                          className="mb-2 form-control"
                          onChange={handleStatus}
                          value={
                            localStorage.getItem("selectStatus")
                              ? localStorage.getItem("selectStatus")
                              : ""
                          }
                        >
                          <option value="" selected="true">
                            Interview Status
                          </option>
                          {check &&
                            rejectionReasonStatus.map((obj) => {
                              return (
                                <option
                                  //selected
                                  value={obj.name}
                                >
                                  {obj.name}
                                </option>
                              );
                            })}
                        </select>
                      </div>
                    )}

                    {/* {interviewRounds !== "Application_Received" && (
                  <div className="col-md-3 px-1">
                    <select
                      id="FormType"
                      className="mb-2 form-control"
                      onChange={handleProcesses}
                      value={
                        localStorage.getItem("selectProcess")
                          ? localStorage.getItem("selectProcess")
                          : ""
                      }
                    >
                      <option value="" selected="true">
                        Process
                      </option>
                      {check &&
                        process.map((obj) => {
                          return (
                            <option
                              //selected
                              value={obj._id}
                            >
                              {obj.name}
                            </option>
                          );
                        })}
                    </select>
                  </div>
                )} */}

                    {!pathCheck.includes(path) &&
                      formIds !== "633190214529e62d9edc2fff" &&
                      formIds !== "62e91154309f9f7d5806d044" && (
                        <div className="col-md-2 px-1">
                          <select
                            id="FormType"
                            className="mb-2 form-control"
                            onChange={handleSelectSource}
                            value={
                              localStorage.getItem("selectSource")
                                ? localStorage.getItem("selectSource")
                                : ""
                            }
                          >
                            <option value="" selected="true">
                              Select Source
                            </option>
                            {
                              check &&
                                selectedSource.map((source) => {
                                  return (
                                    <option value={source}>{source}</option>
                                  );
                                })
                              // <option value="BulkUpload"> Bulk Upload</option>
                              // <option value=""> Others</option>
                            }
                          </select>
                        </div>
                      )}
                    {formIds !== "633190214529e62d9edc2fff" &&
                      formIds !== "62e91154309f9f7d5806d044" && (
                        <div className="col-md-2 px-1">
                          <select
                            id="FormType"
                            className="form-control"
                            onChange={handleScore}
                            value={
                              localStorage.getItem("selectScore")
                                ? localStorage.getItem("selectScore")
                                : ""
                            }
                          >
                            <option value="" selected="true">
                              Test Status
                            </option>
                            {check &&
                              candidateScore.map((obj) => {
                                return <option value={obj}>{obj}</option>;
                              })}
                          </select>
                        </div>
                      )}
                  </div>
                  {/* <div className="row">
                {formIds !== "" && (
                  <div className="col-md-2">
                    <button
                      onClick={showModal}
                      className="btn btn-primary btn-block"
                    >
                      Add New Candidate
                    </button>
                  </div>
                )}
              </div> */}
                </div>
              </div>
              {/* <div className="mt-2 p-3 border bg-white w-100">
            <div className="customSelect select-two">
              <div className="row d-flex">
                <div className="col-md-3">
                   {formIds !== "" && (
                  <div className="border border-2 rounded">
                    <input
                      type="text"
                      // maxlength="10"
                      //onkeypress="return event.charCode>=48 && event.charCode<=57"
                      className="form-control"
                      placeholder="Search..."
                      value={localStorage.getItem("numberSearch")}
                      onChange={handleSearch}
                    />
                    {number !== "" && (
                      <span style={{ color: "red", fontSize: "15px" }}>
                        {number}
                      </span>
                    )}
                  </div>
                   )}  
                </div>
              </div>
            </div>
          </div> */}
            </div>
            {load ? (
              <div>
                {(data.length > 0 && trfData !== "") ||
                (data.length > 0 && formIds !== "") ||
                data.length > 0 ? (
                  <div className="row">
                    <div className="col-md-8 pl-0">
                      <Tabs
                        defaultActiveKey="1"
                        className="w-100 border bg-white px-3 pb-3"
                      >
                        <TabPane tab="Candidates" key="1">
                          <div className="table-responsive">
                            <table className="table bg-white">
                              <thead className="table-head">
                                <tr>
                                  <td style={{ minWidth: "100px" }}>
                                    Form Name
                                  </td>
                                  <td style={{ minWidth: "100px" }}>
                                    Source
                                  </td>
                                  {data.length > 0 &&
                                    candidateField?.length > 0 &&
                                    candidateField?.map((field, key) => (
                                      <td
                                        className="table-column-head"
                                        key={key}
                                      >
                                        {field === "Name" &&
                                          camel2normal(field)}

                                        {/* {field === "Email" && camel2normal(field)} */}
                                        {field === "Phone Number" &&
                                          camel2normal(field)}
                                        {field === "dateApplied" &&
                                          camel2normal(field)}
                                        {/* {field === "Test_Status" &&
                                          camel2normal(field)} */}
                                        {/* {field === "Form Name" &&
                                          camel2normal(field)} */}
                                        {/* {field ===
                                      "How did you come to know about us" &&
                                      camel2normal(field)} */}
                                        {/* <i
                                  onClick={() => {
                                    if (sort === field) {
                                      toggleSortOrder();
                                    } else {
                                      setSort(field);
                                    }
                                  }}
                                  className={
                                    sort === field
                                      ? sortOrder === 0
                                        ? "sort fas fa-fw sort-focus fa-sort-up"
                                        : sortOrder === 1
                                        ? "sort fas fa-fw sort-focus fa-sort-down"
                                        : "sort fas fa-fw sort-focus fa-sort"
                                      : "sort fas fa-fw fa-sort"
                                  }
                                  // fas fa-fw fa-sort
                                ></i> */}
                                      </td>
                                    ))}
                                  {/* <td style={{ minWidth: "25%" }}>Actions</td> */}
                                </tr>
                              </thead>

                              <tbody>
                                {((data.length > 0 && trfData !== "") ||
                                  (data.length > 0 && formIds !== "") ||
                                  data.length > 0) &&
                                  data

                                    // Search
                                    // .filter((candidate) => {
                                    //   if (search == "") return true;
                                    //   let candidateContainsSearch = false;
                                    //   let candidateValues = Object.values(candidate);
                                    //   candidateValues.forEach((value) => {
                                    //     if (typeof value !== "string") return;
                                    //     if (
                                    //       value.toLowerCase().indexOf(search.toLowerCase()) != -1
                                    //     ) {
                                    //       candidateContainsSearch = true;
                                    //     }
                                    //   });
                                    //   return candidateContainsSearch;
                                    // })
                                    // Filters
                                    .filter((candidate) => {
                                      if (positionFilter != null) {
                                        if (
                                          candidate.position !== positionFilter
                                        ) {
                                          return false;
                                        }
                                      }
                                      if (locationFilter != null) {
                                        if (
                                          candidate.location !== locationFilter
                                        ) {
                                          return false;
                                        }
                                      }
                                      if (statusFilter != null) {
                                        if (candidate.status !== statusFilter) {
                                          return false;
                                        }
                                      }
                                      //   // if (startDateFilter != null && endDateFilter == null) {
                                      //   //   const applicationDate = new Date(candidate.dateApplied);
                                      //   //   startDateFilter.setHours(0, 0, 0, 0);
                                      //   //   applicationDate.setHours(0, 0, 0, 0);

                                      //   //   if (
                                      //   //     startDateFilter.getTime() !== applicationDate.getTime()
                                      //   //   ) {
                                      //   //     return false;
                                      //   //   }
                                      //   //   // if (endDateFilter < applicationDate) {
                                      //   //   //   return false;
                                      //   //   // }
                                      //   // }

                                      //   // if (startDateFilter != null && endDateFilter != null) {
                                      //   //   const applicationDate = new Date(candidate.dateApplied);
                                      //   //   if (startDateFilter > applicationDate) {
                                      //   //     return false;
                                      //   //   }
                                      //   //   if (endDateFilter < applicationDate) {
                                      //   //     return false;
                                      //   //   }
                                      //   // }

                                      return true;
                                    })
                                    // Sorts

                                    .sort((a, b) => {
                                      if (sort == null) {
                                        return 0;
                                      }
                                      if (sortOrder === 0) {
                                        return 0;
                                      }

                                      // Return Value of the comparison function
                                      let comparison = 0;
                                      let valueA = (a[sort] + "").toLowerCase();
                                      let valueB = (b[sort] + "").toLowerCase();

                                      comparison = valueA > valueB ? 1 : -1;

                                      // Invert comparison on the basis of sortOrder
                                      if (sortOrder === -1) {
                                        if (comparison === -1) {
                                          comparison = 1;
                                        } else if (comparison === 1) {
                                          comparison = -1;
                                        }
                                      }
                                      return comparison;
                                    })

                                    // Pagination
                                    //.slice(page * pageCount, page * pageCount + pageCount)
                                    // Output Map
                                    .map(
                                      (candidate, k) => {
                                        console.log(candidate,"jjjjjjj")
                                        if(candidate["Onboard Status"] ===
                                        "Yes"){
                                          return (
                                            <tr
                                            style={{
                                              backgroundColor: "#DBF2D9",
                                              borderBottom: "2px solid #DCE2E3",
                                            }}
                                            key={k}
                                            // onDoubleClick={() => MouseEnter(candidate)}
                                            onClick={() =>
                                              mouseClick(candidate)
                                            }
                                            candidate={JSON.stringify(
                                              candidate.personalDetails
                                            )}
                                          >
                                            <td>{candidate["Form Name"]}</td>
                                            <td>
                                              {/* {candidate.uid || (
                                                <span className="text-danger">
                                                  Not Set
                                                </span>
                                              )} */}
                                              {
                                                candidate["How did you come to know about us"]
                                              }
                                            </td>
                                            {/* <td>{candidate["Form Name"]}</td> */}
                                            {candidateField?.length > 0 &&
                                              candidateField
                                                //.filter((field) => field !== "uid")
                                                ?.map((field, key) => (
                                                  <td
                                                    key={key}
                                                    // className="table-candidate-column"
                                                  >
                                                    {field === "Name" ||
                                                    // field === "Email" ||
                                                    field === "Phone Number" ||
                                                    field === "dateApplied" 
                                                    // ||
                                                    // field === "Test_Status"
                                                      ? typeof candidate[
                                                          field
                                                        ] === "object"
                                                        ? JSON.stringify(
                                                            candidate[field]
                                                          )
                                                        : candidate[field]
                                                      : null}
                                                    {/* {field === "ram" && typeof candidate[field] === "object"
                                       ? JSON.stringify(candidate[field])
                                       : candidate[field]} */}
                                                    {/* <Link to=""></Link> */}
                                                  </td>
                                                ))}
                                            <></>
                                          </tr>
                                          )
                                        }else{
                                          return (
                                            <tr
                                            style={{
                                              borderBottom: "2px solid #DCE2E3",
                                            }}
                                            key={k}
                                            // onDoubleClick={() => MouseEnter(candidate)}
                                            onClick={() =>
                                              mouseClick(candidate)
                                            }
                                            candidate={JSON.stringify(
                                              candidate.personalDetails
                                            )}
                                          >
                                            <td>{candidate["Form Name"]}</td>
                                            <td>
                                              {/* {candidate.uid || (
                                                <span className="text-danger">
                                                  Not Set
                                                </span>
                                              )} */}
                                              {
                                                candidate["How did you come to know about us"]
                                              }
                                            </td>
                                            {candidateField?.length > 0 &&
                                              candidateField
                                                //.filter((field) => field !== "uid")
                                                ?.map((field, key) => (
                                                  <td
                                                    key={key}
                                                    // className="table-candidate-column"
                                                  >
                                                    {field === "Name" ||
                                                    // field === "Email" ||
                                                    field === "Phone Number" ||
                                                    field === "dateApplied" 
                                                    // ||
                                                    // field === "Test_Status"
                                                      ? typeof candidate[
                                                          field
                                                        ] === "object"
                                                        ? JSON.stringify(
                                                            candidate[field]
                                                          )
                                                        : candidate[field]
                                                      : null}
                                                    {/* {field === "ram" && typeof candidate[field] === "object"
                                          ? JSON.stringify(candidate[field])
                                          : candidate[field]} */}
                                                    {/* <Link to=""></Link> */}
                                                  </td>
                                                ))}
                                            {/* <td className="table-candidate-column table-column table-control"> */}
                                            {/* {controls ? ( */}
                                            {/* controls(candidate) */}
                                            {/* ) : ( */}
                                            <>
                                              {/* <button
                                            className="btn btn-sm btn-primary btn-table-control mx-1"
                                            candidate={candidate.id}
                                            onClick={onClickView}
                                          >
                                            View
                                          </button> */}
                                              {/* <button
                            className="btn btn-sm btn-primary btn-table-control mx-1"
                            candidate={candidate.id}
                            onClick={onClickEdit}
                          >
                            Edit
                          </button> */}
                                              {/* <button
                              className="btn btn-sm btn-danger btn-table-control mx-1"
                              candidate={candidate.id}
                              onClick={() => {
                                swal({
                                  title: "Are you sure?",
                                  text: "Once deleted, you will not be able to recover the candidate!",
                                  icon: "error",
                                  buttons: true,
                                  dangerMode: true,
                                }).then((willDelete) => {
                                  if (willDelete) {
                                    onClickDelete(candidate.id);
                                  }
                                });
                              }}
                              //disabled={true}
                            >
                              Delete
                            </button> */}

                                              {/* {isAdmin() && (
                                            <button
                                              className="btn btn-sm btn-danger btn-table-control mx-1"
                                              candidate={candidate.id}
                                              onClick={() => {
                                                swal({
                                                  title: "Are you sure?",
                                                  text: "Once deleted, you will not be able to recover the candidate!",
                                                  icon: "error",
                                                  buttons: true,
                                                  dangerMode: true,
                                                }).then((willDelete) => {
                                                  if (willDelete) {
                                                    onClickDelete(candidate.id);
                                                  }
                                                });
                                              }}
                                              disabled={true}
                                            >
                                              Delete
                                            </button>
                                          )} */}

                                              {/* {candidate.personalDetails ===
                                          undefined ? (
                                            <button
                                              className="btn btn-sm btn-primary btn-table-control mx-1"
                                              candidate={candidate.id}
                                              onClick={updateCandidate}
                                              disabled={true}
                                            >
                                              Edit
                                            </button>
                                          ) : (
                                            <button
                                              className="btn btn-sm btn-primary btn-table-control mx-1"
                                              candidate={candidate.id}
                                              onClick={editCandidate}
                                            >
                                              Edit
                                            </button>
                                          )} */}
                                            </>
                                            {/* )} */}
                                            {/* </td> */}
                                          </tr>
                                          )
                                        }
                                      }
                                      //         <tr
                                      //           key={k}
                                      //           // onDoubleClick={() => MouseEnter(candidate)}
                                      //           onClick={() => mouseClick(candidate)}
                                      //           candidate={JSON.stringify(
                                      //             candidate.personalDetails
                                      //           )}
                                      //         >
                                      //           <td>
                                      //             {candidate.uid || (
                                      //               <span className="text-danger">
                                      //                 Not Set
                                      //               </span>
                                      //             )}
                                      //           </td>
                                      //           {candidateField?.length > 0 &&
                                      //             candidateField
                                      //               //.filter((field) => field !== "uid")
                                      //               ?.map((field, key) => (
                                      //                 <td
                                      //                   key={key}
                                      //                   // className="table-candidate-column"
                                      //                 >
                                      //                   {field === "Name" ||
                                      //                   // field === "Email" ||
                                      //                   field === "Phone Number" ||
                                      //                   field === "dateApplied" ||
                                      //                   field === "Test_Status"
                                      //                     ? typeof candidate[field] ===
                                      //                       "object"
                                      //                       ? JSON.stringify(
                                      //                           candidate[field]
                                      //                         )
                                      //                       : candidate[field]
                                      //                     : null}
                                      //                   {/* {field === "ram" && typeof candidate[field] === "object"
                                      //                 ? JSON.stringify(candidate[field])
                                      //                 : candidate[field]} */}
                                      //                   {/* <Link to=""></Link> */}
                                      //                 </td>
                                      //               ))}
                                      //           {/* <td className="table-candidate-column table-column table-control"> */}
                                      //           {/* {controls ? ( */}
                                      //           {/* controls(candidate) */}
                                      //           {/* ) : ( */}
                                      //           <>
                                      //             {/* <button
                                      //                   className="btn btn-sm btn-primary btn-table-control mx-1"
                                      //                   candidate={candidate.id}
                                      //                   onClick={onClickView}
                                      //                 >
                                      //                   View
                                      //                 </button> */}
                                      //             {/* <button
                                      //   className="btn btn-sm btn-primary btn-table-control mx-1"
                                      //   candidate={candidate.id}
                                      //   onClick={onClickEdit}
                                      // >
                                      //   Edit
                                      // </button> */}
                                      //             {/* <button
                                      //     className="btn btn-sm btn-danger btn-table-control mx-1"
                                      //     candidate={candidate.id}
                                      //     onClick={() => {
                                      //       swal({
                                      //         title: "Are you sure?",
                                      //         text: "Once deleted, you will not be able to recover the candidate!",
                                      //         icon: "error",
                                      //         buttons: true,
                                      //         dangerMode: true,
                                      //       }).then((willDelete) => {
                                      //         if (willDelete) {
                                      //           onClickDelete(candidate.id);
                                      //         }
                                      //       });
                                      //     }}
                                      //     //disabled={true}
                                      //   >
                                      //     Delete
                                      //   </button> */}

                                      //             {/* {isAdmin() && (
                                      //                   <button
                                      //                     className="btn btn-sm btn-danger btn-table-control mx-1"
                                      //                     candidate={candidate.id}
                                      //                     onClick={() => {
                                      //                       swal({
                                      //                         title: "Are you sure?",
                                      //                         text: "Once deleted, you will not be able to recover the candidate!",
                                      //                         icon: "error",
                                      //                         buttons: true,
                                      //                         dangerMode: true,
                                      //                       }).then((willDelete) => {
                                      //                         if (willDelete) {
                                      //                           onClickDelete(candidate.id);
                                      //                         }
                                      //                       });
                                      //                     }}
                                      //                     disabled={true}
                                      //                   >
                                      //                     Delete
                                      //                   </button>
                                      //                 )} */}

                                      //             {/* {candidate.personalDetails ===
                                      //                 undefined ? (
                                      //                   <button
                                      //                     className="btn btn-sm btn-primary btn-table-control mx-1"
                                      //                     candidate={candidate.id}
                                      //                     onClick={updateCandidate}
                                      //                     disabled={true}
                                      //                   >
                                      //                     Edit
                                      //                   </button>
                                      //                 ) : (
                                      //                   <button
                                      //                     className="btn btn-sm btn-primary btn-table-control mx-1"
                                      //                     candidate={candidate.id}
                                      //                     onClick={editCandidate}
                                      //                   >
                                      //                     Edit
                                      //                   </button>
                                      //                 )} */}
                                      //           </>
                                      //           {/* )} */}
                                      //           {/* </td> */}
                                      //         </tr>
                                    )}
                              </tbody>
                            </table>
                            {data.length > 0 && (
                              <div className="d-flex">
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                  }}
                                >
                                  <button
                                    className={"page-link"}
                                    disabled={Sli == 10}
                                    onClick={() => {
                                      // if (page - 1 < 0) return;
                                      // setPage(page - 1);
                                      // onPaginate(page - 1);
                                      PreviousButton();
                                    }}
                                  >
                                    Previous
                                  </button>

                                  <div style={{ display: "flex" }}>
                                    {PageNo.slice(Sli - 9, Sli + 1).map(
                                      (val, index) => {
                                        return (
                                          <div key={index}>
                                            <button
                                              className={"page-link"}
                                              onClick={() => GetValue({ val })}
                                            >
                                              {val}
                                            </button>
                                          </div>
                                        );
                                      }
                                    )}
                                  </div>
                                  <button
                                    className={"page-link"}
                                    //disabled={Sli==300}
                                    disabled={
                                      Sli >= Math.ceil(LengthPages / 10) + 1
                                    }
                                    onClick={() => {
                                      // if (totalPages - 1 < page + 1) {
                                      //   return;
                                      // }
                                      // setPage(page + 1);
                                      // onPaginate(page + 1);

                                      NextButton();
                                    }}
                                  >
                                    Next
                                  </button>

                                  {/* <ul
                                // style={{ display: "flex" }}
                                className="pagination"
                              >
                                <li
                                  className="paginate_button page-item previous"
                                  disabled={Sli == 10}
                                  onClick={() => {
                                    // if (page - 1 < 0) return;
                                    // setPage(page - 1);
                                    // onPaginate(page - 1);
                                    PreviousButton();
                                  }}
                                >
                                  <div className="page-link">Previous</div>
                                </li>
                                {PageNo.slice(Sli - 9, Sli + 1).map(
                                  (val, index) => {
                                    return (
                                      <li
                                        key={index}
                                        className="page-link"
                                        onClick={() => GetValue({ val })}
                                      >
                                        {val}
                                      </li>
                                    );
                                  }
                                )}
                                <li
                                  className={"paginate_button page-item next"}
                                  //disabled={Sli==300}
                                  disabled={
                                    Sli >= Math.ceil(LengthPages / 10) + 1
                                  }
                                  onClick={() => {
                                    // if (totalPages - 1 < page + 1) {
                                    //   return;
                                    // }
                                    // setPage(page + 1);
                                    // onPaginate(page + 1);
 
                                    NextButton();
                                  }}
                                >
                                  <div className="page-link">Next</div>
                                </li>
                              </ul> */}
                                </div>
                              </div>
                            )}
                          </div>
                        </TabPane>
                        {/* <TabPane tab="Red Flag" key="2">
                      2
                    </TabPane> */}
                      </Tabs>
                    </div>
                    <div className="col-md-4 card rounded-0 border px-3 pb-3">
                      <Tabs defaultActiveKey="1">
                        <TabPane tab="Details" key="1">
                          {bulkInfo?.IsSelected && (
                            <h4 className="text-success">
                              Candidate Onboarded
                            </h4>
                          )}
                          {candidateInformation?.length > 0 ? (
                            <div className="single-info">
                              {candidateInformation?.map((candidate) => {
                                for (
                                  let i = 0;
                                  i < technicalDetails?.length;
                                  i++
                                ) {
                                  if (
                                    candidate?.label === technicalDetails[i]
                                  ) {
                                    return (
                                      <p className="mb-1">
                                        <b style={{ color: "gray" }}>
                                          {candidate?.label}
                                        </b>
                                        :{" "}
                                        {typeof candidate?.value === "object"
                                          ? JSON.parse(
                                              JSON.stringify(
                                                candidate?.value !== null &&
                                                  candidate?.value?.join(",  ")
                                              )
                                            )
                                          : candidate?.value !== null &&
                                            candidate?.value}
                                      </p>
                                    );
                                  }
                                }
                              })}
                              <p className="mb-1 mt-2">
                                <strong>Interview Status</strong>
                              </p>
                              <b style={{ color: "gray" }}>L1 Round Status:</b>
                              <span> {bulkInfo?.L1_Status}</span>
                              <br />
                              <b style={{ color: "gray" }}>L2 Round Status:</b>
                              <span> {bulkInfo?.L2_Status}</span>
                              <br />
                              <b style={{ color: "gray" }}>L3 Round Status:</b>
                              <span> {bulkInfo?.L3_Status}</span>
                              <br />
                              <b style={{ color: "gray" }}>
                                Client Round Status:
                              </b>
                              <span> {bulkInfo?.L4_Status}</span>
                              <div className="d-flex my-2">
                                <button
                                  className="btn btn-outline-dark mr-4"
                                  onClick={accepted}
                                >
                                  Accepted
                                </button>
                                <button
                                  className="btn btn-outline-dark mr-4"
                                  onClick={candidateHistory}
                                  disabled={checkValid}
                                >
                                  Candidate History
                                </button>
                              </div>
                              <p className="mb-1">
                                <strong>Personal Information</strong>
                              </p>
                              {candidateInformation?.map((candidate) => {
                                for (let i = 0; i < details.length; i++) {
                                  if (candidate.label === details[i]) {
                                   console.log(candidate)

                                    if(candidate?.element?.type === 'date'){
                                      return (
                                        <p className="mb-1">
                                          <b style={{ color: "gray" }}>
                                            {candidate?.label}
                                          </b>
                                          : {formatDateDDMMYYYY(new Date(candidate?.value))}
                                        </p>
                                      );
                                    }else{
                                      return (
                                        <p className="mb-1">
                                          <b style={{ color: "gray" }}>
                                            {candidate?.label}
                                          </b>
                                          : {candidate?.value}
                                        </p>
                                      );
                                    }

                                  }
                                }
                              })}
                              <p className="mb-1">
                                <strong>Activity Status</strong>
                              </p>

                              <p className="mb-1">
                                {logStatus && (
                                  <div className="mb-1">
                                    {" "}
                                    <span style={{ color: "gray" }}>
                                      Call Status:
                                    </span>
                                    <span>
                                      {" "}
                                      {logStatus.callMasterId},{"  "}
                                      {logStatus.callStatusMasterId},{"  "}
                                      {logStatus.callStatusParameterId}
                                    </span>
                                  </div>
                                )}
                              </p>
                              <p className="mb-1">
                                {logDate && (
                                  <div className="mb-1">
                                    {" "}
                                    <span style={{ color: "gray" }}>
                                      Date:{" "}
                                    </span>
                                    <span>{logDate}</span>
                                  </div>
                                )}
                              </p>
                            </div>
                          ) : (
                            <div>
                              {Object.keys(bulkInfo)?.length === 0 &&
                                "Select candidate to View data"}
                            </div>
                          )}
                          {Object.keys(bulkInfo)?.length !== 0 &&
                            bulkInfo?.responses?.length === 0 && (
                              <>
                                <p className="mb-1">
                                  <b style={{ color: "gray" }}> Name </b> :{" "}
                                  {bulkInfo?.name}
                                </p>

                                <p className="mb-1">
                                  <b style={{ color: "gray" }}> Email </b> :{" "}
                                  {bulkInfo?.email}
                                </p>

                                <p className="mb-1">
                                  <b style={{ color: "gray" }}>
                                    {" "}
                                    Phone Number{" "}
                                  </b>{" "}
                                  : {bulkInfo?.mobileNo}
                                </p>

                                <p className="mb-1">
                                  <b style={{ color: "gray" }}> Source </b> :{" "}
                                  {bulkInfo?.sourceType}
                                </p>

                                <p className="mb-1">
                                  <b style={{ color: "gray" }}>
                                    {" "}
                                    Preferred Location{" "}
                                  </b>{" "}
                                  : {bulkInfo?.location}
                                </p>

                                <div className="d-flex my-3">
                                  <button
                                    className="btn btn-outline-dark mr-4"
                                    onClick={accepted}
                                  >
                                    Accepted
                                  </button>
                                </div>
                              </>
                            )}
                        </TabPane>
                      </Tabs>
                    </div>
                  </div>
                ) : (
                  <h3>
                    {error ? (
                      <p style={{ fontWeight: 400 }}>
                        {/* Please, Select{" "}
                    <span className="text-primary" style={{ fontWeight: 600 }}>
                      Trf Type
                    </span>{" "}
                    for candidate information. */}
                        Data not found
                      </p>
                    ) : (
                      "Data not found"
                    )}
                  </h3>
                )}
              </div>
            ) : (
              <ReactLoading type="spin" color="#0000FF" className="spinnerBg" />
            )}
          </div>
          <Modal
            width={1100}
            visible={visible}
            title="Add New Candidate"
            onOk={handleOk}
            onCancel={handleCancel}
            footer={null}
            // footer={[
            //   <Button key="back" onClick={handleCancel}>
            //     Cancel
            //   </Button>,
            // ]}
          >
            <ContactCreator refresh={"refresh"} />
          </Modal>

          {/* Candidate history functionality */}
          <Modal
            title="Candidate History"
            width={1100}
            visible={isModalVisible}
            footer={[
              <>
                <button
                  className="btn btn-secondary"
                  onClick={handleHistoryCancel}
                >
                  Cancel
                </button>
              </>,
            ]}
            onOk={handleHistoryOk}
            onCancel={handleHistoryCancel}
          >
            <CandidateHistory candidateId={phone} />
          </Modal>
        </div>
      )}
    </div>
  );
}

export default CandidatesTable;
